// 견적서: 협상후 단가가 협상전(주문 때) 단가보다 올랐을 때의 표시 판정. 화면 표시 전용 — 금액 계산에는 쓰지 않는다.
// 소수점 부동오차(2.3 vs 2.3000000001)로 오표시되지 않도록 0.005(반올림 단위 0.01 의 절반) 미만 차이는 같음으로 본다.
export function priceRiseInfo (pre, post) {
  const a = Number(pre)
  const b = Number(post)
  if (!isFinite(a) || !isFinite(b) || a <= 0 || b <= 0) return null
  const diff = Math.round((b - a) * 100) / 100
  if (b - a < 0.005) return null
  return { pre: a, post: b, diff }
}

export function priceRiseTitle (info) {
  if (!info) return ''
  return `下单价 ${info.pre} → 卖家改价后 ${info.post} (差额 +${info.diff}) / 주문가 ${info.pre} → 판매자 수정 후 ${info.post} (차액 +${info.diff})`
}
